@use '../../styling/badges.scss' as *;
@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.StatusBadgeIcon {
  @extend %badge-base;

  padding: 0;
  min-width: 100px; //Incomplete is the longest
  white-space: nowrap;
  color: $theme-color-text;
  display: grid;
  gap: 6px;
  grid-template-columns: 15px auto;
  width: max-content;
  text-align: left;

  .value {
    font-weight: $font-weight-bold;
  }

  .iconContainer {
    align-content: center;
    display: grid;
  }
}
